export default __webpack_public_path__ + "static/media/oliva.0e2e3869.png";